import config from '../config';

export default class apiHelper {
    static buildSortFilterParams(sorters, filters) {
        let url = '';
        if (sorters) {
            url = `?sort=${this.state.sorters}`;
        }
        if (filters && filters.length > 0) {
            const filterStr = encodeURIComponent(JSON.stringify(filters));
            if (sorters) url = url + `&filter=${filterStr}`;
            else url = url + `?filter=${filterStr}`;
        }

        return url;
    }

    static parseError(rejectReason) {
        if (!rejectReason) return config.defaultErrorMessage;
        if (rejectReason.response && typeof rejectReason.response.data === 'string') return rejectReason.response.data;
        let exMessage =  
        rejectReason.response && rejectReason.response.data && rejectReason.response.data.ExceptionMessage
            ? rejectReason.response.data.ExceptionMessage
            : '';

        let msg =
            rejectReason.response && rejectReason.response.data && rejectReason.response.data.Message
                ? rejectReason.response.data.Message
                : rejectReason.message;
                if(exMessage){
                    msg = `${msg} (${exMessage})`;    
                }
                
        if (msg) {
            if (msg === 'Network Error') {
                msg = config.defaultNetworkErrorMessage;
            }
            return msg;
        } else {
            //console.warn('Failure Response: ', rejectReason);
            return config.defaultErrorMessage;
        }
    }

    static getPaymentMethodLabel(method) {
        if (!method) return '';
        if (method.PaymentType === 1) {
            return (method.Name || '') + ': ' + (method.CardBrand || '') + ' ****' + (method.LastFour || '');
        }
        return (method.NameOnAch || '') + ': ' + (method.BankName || '') + ' ****' + (method.LastFour || '');
    }
}
